import axios from 'axios'
import router from '../router'
import store from '../store'

// Configure axios to include credentials in requests
axios.defaults.withCredentials = true

// Track auth check requests to prevent loops
const pendingAuthCheck = {
  isCheckingAuth: false
}

// Add response interceptor to handle 401 errors
axios.interceptors.response.use(
  response => response,
  error => {
    // Don't redirect if this is a /me request during auth check
    const isAuthCheckRequest = 
      error.config?.url?.includes('/user/me') && 
      pendingAuthCheck.isCheckingAuth;
      
    if (error.response?.status === 401 && !isAuthCheckRequest) {
      // Only redirect if not already on login page
      if (router.currentRoute.value.path !== '/login') {
        store.dispatch('auth/logout')
        router.push('/login')
      }
    }
    return Promise.reject(error)
  }
)

export { axios, pendingAuthCheck } 